<template>
	<div class="bcgl">
		<div style="margin: 0rem 0 0 0rem; border: 1px #DDDDDD solid;">
			<el-card class="box-card">
				<div slot="header">
					<el-row style="margin-bottom: 20px">
						<el-col :span="24">
							<div style="line-height: 3rem; font-size: 1.5rem;">报废资产管理</div>
						</el-col>

					</el-row>
					<el-row style="text-align: left">
						<el-form :inline="true" :model="searchForm" @keyup.enter.native="searchData()">
							<el-form-item label="固定资产编号">
								<el-input style="width: 160px" @change="changIndex" v-model="searchForm.assetNumber" clearable></el-input>
							</el-form-item>
							<el-form-item label="名称">
								<el-input style="width: 160px" @change="changIndex" v-model="searchForm.name" clearable></el-input>
							</el-form-item>
							<el-form-item label="类别">
								<el-select clearable  style="width: 160px" filterable  v-model="searchForm.typeId" placeholder="类别">
									<el-option v-for="item in types" :key="item.id" :label="item.name" :value="item.id"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="开始使用日期">
								<el-date-picker
										@change="changIndex"
										v-model="startTime2"
										type="daterange"
										value-format="yyyy-MM-dd"
										range-separator="至"
										start-placeholder="开始日期"
										end-placeholder="结束日期">
								</el-date-picker>
							</el-form-item>
							<el-form-item>
								<el-button @click="searchData()">查询</el-button>
<!--								<el-button v-if="isAuth('asset:add')" type="primary" @click="addOrUpdate()" icon="el-icon-plus" style="display: inline;">添加</el-button>-->
								<el-button v-if="isAuth('asset:delete')"  type="danger" @click="deleteHandle()">批量删除
								</el-button>
							</el-form-item>
							<el-collapse v-model="activeNames" >
								<el-collapse-item title="更多条件" name="1">
									<el-form-item label="等级日期">
										<el-date-picker
												@change="changIndex"
												v-model="startTime"
												type="daterange"
												value-format="yyyy-MM-dd"
												range-separator="至"
												start-placeholder="开始日期"
												end-placeholder="结束日期">
										</el-date-picker>
									</el-form-item>
									<el-form-item label="原值(元)">
										<el-col :span="11" >
											<el-input-number @change="changIndex" controls-position="right" v-model="amount[0]" clearable></el-input-number>
										</el-col>
										<el-col class="line"  style="text-align: center" :span="2">-</el-col>
										<el-col :span="11" >
											<el-input-number @change="changIndex" controls-position="right" v-model="amount[1]" clearable></el-input-number>
										</el-col>
									</el-form-item>
								</el-collapse-item>
							</el-collapse>
						</el-form>
					</el-row>
				</div>

				<el-table
						@selection-change="selectionChangeHandle"
						:data="contractList" v-loading="loading" style="text-align: center; width: 100%;">
					<el-table-column
							type="selection"
							header-align="center"
							align="center"
							width="50">
					</el-table-column>
					<el-table-column prop="assetNumber" label="固定资产编号" width="120">
					</el-table-column>
					<el-table-column prop="name" label="名称" width="150" show-overflow-tooltip>
					</el-table-column>
					<el-table-column prop="typeName" label="类别" >
						<template slot-scope="scope">
							<el-tag type="success">{{scope.row.typeName}}</el-tag>
						</template>
					</el-table-column>
					<el-table-column  prop="beginUseTime" label="开始使用日期" width="130">
					</el-table-column>

					<el-table-column   label="使用年限" width="100">
						<template slot-scope="scope">
							{{scope.row.allUseTimeYear+'年'+scope.row.allUseTimeMonth+'月'}}
						</template>
					</el-table-column>
					<el-table-column  prop="bfrq" label="报废时间" width="130">
					</el-table-column>


					<el-table-column  label="原值(元)" prop="yz" width="100">
						<template slot-scope="scope">
							{{toThousands(scope.row.yz)}}
						</template>
					</el-table-column>
					<el-table-column  label="累计折旧(元)"  prop="ljzj" width="100">
						<template slot-scope="scope">
							{{toThousands(scope.row.ljzj)}}
						</template>
					</el-table-column>
					<el-table-column  label="净值(元)"  prop="jz" width="100">
						<template slot-scope="scope">
							{{toThousands(scope.row.jz)}}
						</template>
					</el-table-column>
					<el-table-column  label="净残值(元)"  prop="jcz" width="100">
						<template slot-scope="scope">
							{{toThousands(scope.row.jcz)}}
						</template>
					</el-table-column>
					<el-table-column  label="营业外收入(元)"  prop="jcz" width="120">
						<template slot-scope="scope">
							{{toThousands(scope.row.yywsr)}}
						</template>
					</el-table-column>
					<el-table-column  label="清理费用(元)"  prop="jcz" width="100">
						<template slot-scope="scope">
							{{toThousands(scope.row.qlfy)}}
						</template>
					</el-table-column>
					<el-table-column  label="固定资产净支出(元)"  prop="jcz" width="120">
						<template slot-scope="scope">
							{{toThousands(scope.row.gdzcjzc)}}
						</template>
					</el-table-column>
					<el-table-column label="操作" width="180" fixed="right" :render-header="renderHeader">
						<template slot-scope="scope">
							<el-button type="text" size="mini"  @click="showInfo(scope.row)">详情</el-button>
							<el-button type="text" size="mini"  @click="setBf(scope.row)">修改</el-button>

							<el-button type="text" size="mini" v-if="isAuth('asset:delete')" @click="deleteHandle(scope.row.id)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentNo"
				 :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal">
				</el-pagination>
			</el-card>
		</div>
		<el-dialog
				style="text-align: left"
				title="导出"
				:visible.sync="exportVisible"
		>
			<el-form :model="exportForm" ref="exportForm" :rules="exportRules">
				<el-form-item>
					<el-form-item label="报废日期" prop="bfrq">
						<el-date-picker
								v-model="exportForm.bfrq"
								value-format="yyyy"
								type="year"
								placeholder="选择日期">
						</el-date-picker>
					</el-form-item>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
    <el-button @click="exportVisible = false">取 消</el-button>
    <el-button type="primary" @click="exportExcel">确 定</el-button>
  </span>
		</el-dialog>
		<add-or-update v-if="customerVisible" ref="customer" @refreshDataList="searchData"></add-or-update>
<!--		<show-file v-if="showfileVisible" ref="showfile"></show-file>-->
		<show-info  v-if="showInfoVisible" ref="showinfo"></show-info>
		<asset-bf v-if="bfVisible" ref="bf" @refreshDataList="searchData"></asset-bf>
	</div>
</template>
<script>
	import {
		Vue,
		Component
	} from 'vue-property-decorator'
	import AddOrUpdate from './asset-add-or-update'
	import ShowInfo from './asset-info'
	import AssetBf from './asset-bf'
	import Template from "@/template.vue";
	// import Template from "@/template.vue";
	// import ShowFile from './contract-showfile'
	// import ConInfo from './contract-info'
	// import fa from "element-ui/src/locale/lang/fa";
	@Component({
		name: 'contractinfo',
		components:{
			Template,
			AddOrUpdate,
			ShowInfo,
			AssetBf
			// ShowFile,
			// ConInfo
		}
	})
	export default class contractinfo extends Vue {
		customerVisible=false
		currentNo = 1;
		pageSize= 10;
		pageTotal = 0;
		activeNames=[];
		showbmxxVisible = false;
		customerList=[]
		contractList=[]
		showfileVisible=false
		showInfoVisible=false
		bfVisible=false
		types=[]
		amount=[]
		searchForm= {
			assetNumber: '',
			status:1,
			startTimest: '',
			startTimeed: '',
			beginTimest:'',
			beginTimeed:'',
			amountst:'',
			amounted:'',
			name:'',
			typeId:'',
			id:''
		}
		startTime=[]
		exportVisible=false
		exportForm={bfrq:''}
		exportRules={bfrq: [{required: true, message: '请选择报废日期', trigger: 'blur'}]}
		startTime2=[]
		loading = false;
		dataListSelections=[];
		selectBm=''
		created() {
			this.searchData();
			this.getTypes();
		}
		handleSizeChange(val) {
			this.pageSize = val;
			this.searchData();
		}
		handleCurrentChange(val) {
			this.currentNo = val;
			this.searchData();
		}
		getTypes() {
			let that = this;
			this.$request.get('/bjba/asset/type/queryAll').then(res => {
				that.types = res.data.data
			})
		}
		renderHeader (h) {
			return (
					<div class="clearfix">
						<span>操作</span>
						<el-button style="padding:5px;float:right" size="mini"
								   onClick={()=>this.showExportDialog()}>导出</el-button></div>
			)
		}
		showExportDialog() {
			this.exportVisible = true
		}
		exportExcel(id) {
			this.$refs.exportForm.validate((valid) => {
				if (valid) {
					console.log(this.exportForm.bfrq)
					var viewUrl = this.$request.defaults.baseURL+'/bjba/asset/exportBfExcel?year='+this.exportForm.bfrq+'&access_token='+this.$store.getters.token
					window.open(viewUrl)
				}
			})

		}
		showInfo(row){

			this.showInfoVisible = true
			this.$nextTick(() => {
				this.$refs.showinfo.init(row)
			})
		}
		setBf(row) {
			this.bfVisible = true
			this.$nextTick(() => {
				this.$refs.bf.init(row,1)
			})
		}
		changIndex() {
			this.currentNo =1
		}
		getParams() {
			if(this.startTime &&this.startTime.length==2){
				this.searchForm.startTimest = this.startTime[0]
				this.searchForm.startTimeed = this.startTime[1]
			} else{
				this.searchForm.startTimest = ''
				this.searchForm.startTimeed = ''
			}
			if(this.startTime2 &&this.startTime2.length==2){
				this.searchForm.beginTimest = this.startTime2[0]
				this.searchForm.beginTimeed = this.startTime2[1]
			} else{
				this.searchForm.beginTimest = ''
				this.searchForm.beginTimeed = ''
			}
			if(this.amount && (this.amount[0] || this.amount[1])) {
				this.searchForm.amountst =this.amount[0]
				this.searchForm.amounted = this.amount[1]
			} else {
				this.searchForm.amountst = ''
				this.searchForm.amounted =''
			}
			this.searchForm.page = this.currentNo
			this.searchForm.pagesize = this.pageSize
		}
		searchData() {
			this.getParams();
			this.loading = true;
			this.$request({
					url: '/bjba/asset/page',
					method: 'get',
					params: this.searchForm
				})
				.then(response => {
					this.loading = false;
					console.log(response);
					let data = response.data;
					if (data.code == 200) {
						this.contractList = data.data.content;
						this.pageTotal = data.data.totalElements
					} else {
						this.$message.error(data.message)
					}
				})
				.catch(error => {
					this.loading = false;
					console.log(error)
					this.$message.error(error)
				});
		}
		// 多选
		selectionChangeHandle (val) {
			this.dataListSelections = val
		}
		toThousands(num) {
			if(num) {
				var result = [ ], counter = 0;
				num = (num || 0).toString().split('');
				for (var i = num.length - 1; i >= 0; i--) {
					counter++;
					result.unshift(num[i]);
					if (!(counter % 3) && i != 0 && num[i] !='.') { result.unshift(','); }
				}
				return result.join('');
			}
		}
		addOrUpdate(val) {

			this.customerVisible = true
			this.$nextTick(() => {
				this.$refs.customer.init(val)
			})

		}
		deleteHandle (id) {
			let ids = id ? [id] : this.dataListSelections.map(item => {
				return item.id
			})
			if(!ids || ids.length==0) return
			this.$confirm(`确定进行[删除]操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: `/bjba/asset/delete`,
					method: 'post',
					data: ids
				}).then(({data}) => {
					if (data && data.code === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500
						})
						this.searchData()
					} else if(data && data.code ==500) {
						this.$message({
							message: data.message,
							type: 'error',
							duration: 1500
						})
					}
				})
			}).catch(() => {
			})
		}
	}
</script>
<style lang="scss" scoped>
	.bcgl {}
</style>
